import { z } from "zod";
const JobStatusSchema = z.object({
  name: z.string().optional().nullable(),
  count: z.number().optional().nullable()
});
const AccountSchema = z.object({
  balance: z.number().optional().nullable(),
  point: z.number().optional().nullable(),
  coupon: z.number().optional().nullable(),
  accountNumber: z.string().optional().nullable()
});
const CustomerSchema = z.object({
  id: z.string(),
  externalId: z.string().optional().nullable().describe("\uC678\uBD80 \uC2DC\uC2A4\uD15C\uC5D0\uC11C \uC0AC\uC6A9\uD558\uB294 \uACE0\uAC1D ID"),
  name: z.string(),
  company: z.string().optional().nullable(),
  email: z.string().email().optional().nullable(),
  phone: z.string().optional().nullable(),
  address: z.object({
    address1: z.string().optional().nullable(),
    address2: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    dong: z.string().optional().nullable(),
    sgg: z.string().optional().nullable(),
    si: z.string().optional().nullable()
  }).optional().nullable(),
  metadata: z.record(z.any()).optional(),
  membership: z.string().optional().nullable().describe("\uD68C\uC6D0\uB4F1\uAE09"),
  jobStatus: z.array(JobStatusSchema).optional().nullable().describe("\uACE0\uAC1D\uC758 \uC791\uC5C5 \uC0C1\uD0DC"),
  account: AccountSchema.optional().nullable(),
  anonymous: z.boolean().nullish().describe("\uC775\uBA85 \uB85C\uADF8\uC778 \uC5EC\uBD80"),
  storeId: z.string().nullish().describe("\uC0C1\uC810 ID")
});
export {
  AccountSchema,
  CustomerSchema,
  JobStatusSchema
};
//# sourceMappingURL=customer.js.map